<template>
        <router-view></router-view>
</template>

<script>
    export default {
        name: "transfer"
    }
</script>

<style scoped>

</style>